import { hideAll as hideAllTippys } from 'tippy.js'
import { listenForKeyboardShortcut } from './keyboard'

const listenersById = {}
let stack = []
let id = 1

const filterStack = (id) => {
	stack = stack.filter((s) => s !== id)
}

export const addEscapeListener = (callback) => {
	if (!callback) return null
	const newId = id++
	listenersById[newId] = callback
	stack.push(newId)
	const remover = () => removeEscapeListener(newId)
	remover._escapeId = newId
	return remover
}

export const removeEscapeListener = (id) => {
	id = id?._escapeId ?? id
	if (!id || !listenersById[id]) return false
	delete listenersById[id]
	filterStack(id)
	return true
}

export const clearEscapeListeners = () => {
	return Object.keys(listenersById).map(removeEscapeListener)
}

listenForKeyboardShortcut('Esc', () => {
	// don't change stack if there are tippys visible on the page
	if (document.querySelector('.tippy-box')) {
		hideAllTippys()
		return
	}
	if (!stack.length) return
	// otherwise, pop next id off stack and call associated handler
	const poppedId = stack.pop()
	const handler = listenersById[poppedId]
	handler && handler()
	delete listenersById[id]
})
